import { Component, Input, OnDestroy, OnInit, input } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { Breadcrumb } from '@shared/data-access/interfaces';
import { HmfTextLinkComponent } from '@dsg-tech/homefield-angular';
import { NgClass } from '@angular/common';
import { Store } from '@ngrx/store';
import { selectSEOBreadcrumbs } from '@plp/data-access/state';

@Component({
    selector: 'plp-components-breadcrumb',
    imports: [NgClass, HmfTextLinkComponent],
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss']
})
export class PlpBreadcrumbComponent implements OnInit, OnDestroy {
	@Input() searchTerm = '';
	@Input() isSearchPage = false;
	breadcrumbsEnabled = input(false);

	private readonly destroy$ = new Subject<void>();
	breadcrumbs: Breadcrumb[] = [];
	/* This array will be used to set data-em attribute for each breadcrumb in incrementing length
	 * ex. Breadcrumb_firstBreadcrumbName,
	 * Breadcrumb_firstBreadcrumbName_secondBreadcrumbName,
	 * Breadcrumb_firstBreadcrumbName_secondBreadcrumbName_thirdBreadcrumbName
	 */
	dataEm: string[] = [];

	constructor(private store: Store) {}

	ngOnInit(): void {
		// Get and set the breadcrumbs
		this.store
			.select(selectSEOBreadcrumbs)
			.pipe(takeUntil(this.destroy$))
			.subscribe((breadcrumbsData: Breadcrumb[]) => {
				this.breadcrumbs = breadcrumbsData || [];
				if (this.breadcrumbs.length > 0) {
					this.buildDataEmStringForEachBreadcrumb(this.breadcrumbs);
				}
			});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	buildDataEmStringForEachBreadcrumb(breadcrumbs: Breadcrumb[]): void {
		const regexSpaceSelector = / /g;

		this.dataEm = breadcrumbs.map((breadcrumb, index) =>
			breadcrumbs
				.slice(0, index + 1)
				.map((bc) => bc.note || bc.name)
				.join('_')
				.replace(regexSpaceSelector, '')
		);
	}

	protected trackByFn(index: number, item: Breadcrumb): string {
		return index.toString() + item.name;
	}
}
